// This script enables the cart notification popup when adding to cart from the halo (collection) page.
// It now mimics the product page logic, updating the cart notification content with the correct product info.

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".add-to-cart-btn").forEach((button) => {
    button.addEventListener("click", async function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      const btn = this;

      // Skip if button is sold out
      if (btn.classList.contains("sold-out") || btn.disabled) {
        return;
      }

      const originalText = btn.textContent;
      btn.textContent = "Adding…";
      btn.disabled = true;
      const variantId = btn.getAttribute("data-variant-id");
      if (!variantId) return;

      // Prepare the sections to update (from cart-notification.js)
      const sections = [
        "cart-notification-product",
        "cart-notification-button",
        "cart-icon-bubble",
      ];
      const formData = new FormData();
      formData.append("id", variantId);
      formData.append("quantity", 1);
      formData.append("sections", sections.join(","));
      formData.append("sections_url", window.location.pathname);

      // Add to cart via AJAX and request the notification sections
      let response,
        error = false;
      try {
        response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          },
          body: formData,
        });
      } catch (err) {
        error = true;
      }

      if (response && response.ok) {
        const data = await response.json();
        // Now fetch the updated sections HTML
        const params = new URLSearchParams({
          sections: sections.join(","),
          sections_url: window.location.pathname,
        });
        const htmlResponse = await fetch(`/cart?${params.toString()}`, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          },
        });
        if (htmlResponse.ok) {
          const htmlData = await htmlResponse.json();
          // Update the cart notification content
          if (htmlData["cart-notification-product"]) {
            document.getElementById("cart-notification-product").innerHTML =
              htmlData["cart-notification-product"];
          }
          if (htmlData["cart-notification-button"]) {
            const btn = document.getElementById("cart-notification-button");
            if (btn) btn.innerHTML = htmlData["cart-notification-button"];
          }
          if (htmlData["cart-icon-bubble"]) {
            const bubble = document.getElementById("cart-icon-bubble");
            if (bubble) bubble.innerHTML = htmlData["cart-icon-bubble"];
          }
        }
        // Open the cart notification popup
        const cartNotification = document.querySelector("cart-notification");
        if (cartNotification && typeof cartNotification.open === "function") {
          cartNotification.open();
        } else {
          // Fallback: open cart drawer if it exists
          const cartDrawer = document.querySelector("cart-drawer");
          if (cartDrawer && typeof cartDrawer.open === "function") {
            cartDrawer.open();
          }
        }
      } else {
        // Optionally, show error feedback to the user
        alert("Error adding to cart.");
      }
      btn.textContent = response && response.ok ? "Added!" : "Add to Cart";
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1500);
    });
  });
});
